import React from 'react'
import Radium from 'radium'
import colors from '../../theme/colors'
import borderRadius from '../../theme/borderRadius'
import boxShadow from '../../theme/boxShadow'

import Row from './Row'
import budget from '../../lib/calculations/budget'

export default Radium(({ form }) => (
  <div style={[styles.container, budget(form) < 0 && styles.negative.container]}>
    <Row
      label='Under/over budget'
      value={budget(form)}
      colorful
      bold
      noTopLine
    />
  </div>
))

const styles = {
  container: {
    width: 'calc(100% - 6px)',
    margin: '0 auto',
    boxSizing: 'border-box',
    padding: '10px 20px 0',
    backgroundColor: colors.green,
    color: colors.white,
    borderRadius: `0 0 ${borderRadius} ${borderRadius}`,
    boxShadow,
  },
  negative: {
    container: {
      backgroundColor: colors.reddish,
    },
  },
}
